import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FAIcon from "../FAIcon/FAIcon";
import Loading from "../Loading/Loading";
const SortableTH = ({ sort, isLoading, children, onClick, isCentered, }) => (_jsx("th", { className: isCentered ? "text-center" : "", children: _jsxs("button", { className: "btn btn-link pb-0 font-weight-bold" +
            (isCentered ? " text-center" : " pl-0"), onClick: onClick, children: [children, _jsx(Icon, { sort: sort, isLoading: isLoading }), " "] }) }));
const Icon = ({ sort, isLoading, }) => {
    if (isLoading) {
        return (_jsx("span", { className: "ml-2", children: _jsx(Loading, {}) }));
    }
    // @ts-expect-error - TS2345 - Argument of type 'string | boolean | null' is not assignable to parameter of type 'string'.
    if (!["asc", "desc"].includes(sort)) {
        return null;
    }
    return (_jsx("span", { className: "ml-2", children: _jsx(FAIcon, { icon: sort === "asc" ? "chevron-down" : "chevron-up" }) }));
};
export default SortableTH;
